export default __webpack_public_path__ + "static/dogs-0d8f71e8b663f6832dd27eefa23dbd24.jpg";